<template>
    <div class="form">
        <section class="form-section">
            <div class="form-section-heading">
                {{ trans('user_groups.headline.user_group_information') }}
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="name"
                        :required="true"
                        v-model="fields.name"
                    >
                        {{ trans('user_groups.label.name') }}
                    </form-input>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col">
                    <form-text-area
                        name="description"
                        :required="true"
                        v-model="fields.description"
                    >
                        {{ trans('user_groups.label.description') }}
                    </form-text-area>
                </div>
            </div>
        </section>

        <div class="page-control">
            <div class="page-control__element">
                <button type="submit" class="btn btn--big btn--primary">{{ trans('buttons.submit') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        'userGroup' : {
            type: Object,
            default: () => { return {} }
        },
    },

    data() {
        return {
            fields: {
                name: this.old('name', this.userGroup.name),
                description: this.old('description', this.userGroup.description),
            }
        };
    }
}
</script>
